import { ELevelResult } from 'Shared/types';
import { VariantViewRoute, } from 'Router/index';
export const route = VariantViewRoute.createSubroute({
    levelResult: ELevelResult.Variant,
}, '/:traitsType?');
